import { render, staticRenderFns } from "./MeaningItem.vue?vue&type=template&id=5dcecb3a"
import script from "./MeaningItem.vue?vue&type=script&lang=js"
export * from "./MeaningItem.vue?vue&type=script&lang=js"
import style0 from "./MeaningItem.vue?vue&type=style&index=0&id=5dcecb3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports